import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fire-and-forget product analytics. Never blocks or throws into the UI.
export function track(name, props = {}) {
  try {
    axios.post(`${API}/events/track`, { name, props }).catch(() => {});
  } catch {
    /* ignore */
  }
}
